// Bet4Peer Tournament Contract Configuration
// Deployed on Base, Arbitrum, and Polygon Mainnet

export const TOURNAMENT_CONTRACT_ADDRESS = "0x821E8F4d7A9C533F69ad89B91885B8CB304a32a4";

export const TOURNAMENT_CONTRACT_ABI = [
    // ============ Read Functions ============
    {
        type: "function",
        name: "getTournament",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [{
            name: "",
            type: "tuple",
            components: [
                { name: "id", type: "uint256" },
                { name: "name", type: "string" },
                { name: "tournamentType", type: "uint8" },
                { name: "status", type: "uint8" },
                { name: "entryFee", type: "uint256" },
                { name: "prizePool", type: "uint256" },
                { name: "platformContribution", type: "uint256" },
                { name: "maxParticipants", type: "uint256" },
                { name: "minParticipants", type: "uint256" },
                { name: "startTime", type: "uint256" },
                { name: "endTime", type: "uint256" },
                { name: "participantCount", type: "uint256" },
                { name: "isTeamTournament", type: "bool" },
                { name: "teamSize", type: "uint256" },
                { name: "prizeDistribution", type: "uint256[]" }
            ]
        }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "getParticipant",
        inputs: [
            { name: "_tournamentId", type: "uint256" },
            { name: "_participant", type: "address" }
        ],
        outputs: [{
            name: "",
            type: "tuple",
            components: [
                { name: "wallet", type: "address" },
                { name: "score", type: "uint256" },
                { name: "teamId", type: "uint256" },
                { name: "hasJoined", type: "bool" },
                { name: "hasClaimed", type: "bool" }
            ]
        }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "getTournamentParticipants",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [{ name: "", type: "address[]" }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "getTournamentWinners",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [{ name: "", type: "address[]" }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "getTeam",
        inputs: [{ name: "_teamId", type: "uint256" }],
        outputs: [{
            name: "",
            type: "tuple",
            components: [
                { name: "id", type: "uint256" },
                { name: "name", type: "string" },
                { name: "captain", type: "address" },
                { name: "members", type: "address[]" },
                { name: "score", type: "uint256" },
                { name: "isActive", type: "bool" }
            ]
        }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "getPrizeDistribution",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [{ name: "", type: "uint256[]" }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "getSeasonPoints",
        inputs: [
            { name: "_seasonId", type: "uint256" },
            { name: "_player", type: "address" }
        ],
        outputs: [{ name: "", type: "uint256" }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "nextTournamentId",
        inputs: [],
        outputs: [{ name: "", type: "uint256" }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "nextTeamId",
        inputs: [],
        outputs: [{ name: "", type: "uint256" }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "platformFeePercent",
        inputs: [],
        outputs: [{ name: "", type: "uint256" }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "treasury",
        inputs: [],
        outputs: [{ name: "", type: "address" }],
        stateMutability: "view"
    },
    {
        type: "function",
        name: "owner",
        inputs: [],
        outputs: [{ name: "", type: "address" }],
        stateMutability: "view"
    },
    
    // ============ Write Functions ============
    // Admin Functions
    {
        type: "function",
        name: "createTournament",
        inputs: [
            { name: "_name", type: "string" },
            { name: "_tournamentType", type: "uint8" },
            { name: "_entryFee", type: "uint256" },
            { name: "_maxParticipants", type: "uint256" },
            { name: "_minParticipants", type: "uint256" },
            { name: "_startTime", type: "uint256" },
            { name: "_endTime", type: "uint256" },
            { name: "_isTeamTournament", type: "bool" },
            { name: "_teamSize", type: "uint256" },
            { name: "_prizeDistribution", type: "uint256[]" }
        ],
        outputs: [{ name: "", type: "uint256" }],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "startTournament",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "endTournament",
        inputs: [
            { name: "_tournamentId", type: "uint256" },
            { name: "_winners", type: "address[]" }
        ],
        outputs: [],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "cancelTournament",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "updateScores",
        inputs: [
            { name: "_tournamentId", type: "uint256" },
            { name: "_participants", type: "address[]" },
            { name: "_scores", type: "uint256[]" }
        ],
        outputs: [],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "createSeason",
        inputs: [
            { name: "_name", type: "string" },
            { name: "_startTime", type: "uint256" },
            { name: "_endTime", type: "uint256" }
        ],
        outputs: [{ name: "", type: "uint256" }],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "addTournamentToSeason",
        inputs: [
            { name: "_seasonId", type: "uint256" },
            { name: "_tournamentId", type: "uint256" }
        ],
        outputs: [],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "awardSeasonPoints",
        inputs: [
            { name: "_seasonId", type: "uint256" },
            { name: "_player", type: "address" },
            { name: "_points", type: "uint256" }
        ],
        outputs: [],
        stateMutability: "nonpayable"
    },
    // Player Functions
    {
        type: "function",
        name: "joinTournament",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [],
        stateMutability: "payable"
    },
    {
        type: "function",
        name: "leaveTournament",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "contributeToPrizePool",
        inputs: [{ name: "_tournamentId", type: "uint256" }],
        outputs: [],
        stateMutability: "payable"
    },
    {
        type: "function",
        name: "createTeam",
        inputs: [{ name: "_name", type: "string" }],
        outputs: [{ name: "", type: "uint256" }],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "addTeamMember",
        inputs: [
            { name: "_teamId", type: "uint256" },
            { name: "_member", type: "address" }
        ],
        outputs: [],
        stateMutability: "nonpayable"
    },
    {
        type: "function",
        name: "registerTeamForTournament",
        inputs: [
            { name: "_tournamentId", type: "uint256" },
            { name: "_teamId", type: "uint256" }
        ],
        outputs: [],
        stateMutability: "payable"
    },
    
    // ============ Events ============
    {
        type: "event",
        name: "TournamentCreated",
        inputs: [
            { name: "tournamentId", type: "uint256", indexed: true },
            { name: "name", type: "string", indexed: false },
            { name: "tournamentType", type: "uint8", indexed: false },
            { name: "entryFee", type: "uint256", indexed: false },
            { name: "maxParticipants", type: "uint256", indexed: false },
            { name: "startTime", type: "uint256", indexed: false },
            { name: "endTime", type: "uint256", indexed: false },
            { name: "isTeamTournament", type: "bool", indexed: false }
        ]
    },
    {
        type: "event",
        name: "ParticipantJoined",
        inputs: [
            { name: "tournamentId", type: "uint256", indexed: true },
            { name: "participant", type: "address", indexed: true },
            { name: "teamId", type: "uint256", indexed: false }
        ]
    },
    {
        type: "event",
        name: "ParticipantLeft",
        inputs: [
            { name: "tournamentId", type: "uint256", indexed: true },
            { name: "participant", type: "address", indexed: true }
        ]
    },
    {
        type: "event",
        name: "TournamentEnded",
        inputs: [
            { name: "tournamentId", type: "uint256", indexed: true },
            { name: "winners", type: "address[]", indexed: false },
            { name: "prizes", type: "uint256[]", indexed: false }
        ]
    },
    {
        type: "event",
        name: "PrizeClaimed",
        inputs: [
            { name: "tournamentId", type: "uint256", indexed: true },
            { name: "winner", type: "address", indexed: true },
            { name: "amount", type: "uint256", indexed: false },
            { name: "rank", type: "uint256", indexed: false }
        ]
    },
    {
        type: "event",
        name: "TeamCreated",
        inputs: [
            { name: "teamId", type: "uint256", indexed: true },
            { name: "name", type: "string", indexed: false },
            { name: "captain", type: "address", indexed: false }
        ]
    },
    {
        type: "event",
        name: "TeamRegistered",
        inputs: [
            { name: "tournamentId", type: "uint256", indexed: true },
            { name: "teamId", type: "uint256", indexed: true }
        ]
    },
    {
        type: "event",
        name: "PrizePoolContributed",
        inputs: [
            { name: "tournamentId", type: "uint256", indexed: true },
            { name: "contributor", type: "address", indexed: true },
            { name: "amount", type: "uint256", indexed: false }
        ]
    }
];

// Tournament status enum
export const TOURNAMENT_STATUS = {
    0: 'created',
    1: 'active',
    2: 'ended',
    3: 'cancelled'
};

// Tournament type enum
export const TOURNAMENT_TYPE = {
    0: 'win_streak',
    1: 'volume',
    2: 'profit',
    3: 'oracle',
    4: 'custom'
};

// Default prize distributions
export const PRIZE_DISTRIBUTIONS = {
    TOP_3: [5000, 3000, 2000],  // 50%, 30%, 20%
    TOP_5: [4000, 2500, 1500, 1000, 1000],  // 40%, 25%, 15%, 10%, 10%
    WINNER_TAKES_ALL: [10000]  // 100%
};
